// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formatted-value {
  width: 100%;
}
.formatted-value .overflow-hidden {
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.formatted-value.has-ng-content {
  display: inline-block;
}
.formatted-value.has-ng-content .formatted-value-display {
  width: 75%;
  display: inherit;
}`, "",{"version":3,"sources":["webpack://./src/shared/display-value/formatted-value/formatted-value.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AACI;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;AACR;AAEI;EACI,qBAAA;AAAR;AAEQ;EACI,UAAA;EACA,gBAAA;AAAZ","sourcesContent":[".formatted-value {\r\n    width: 100%;\r\n\r\n    .overflow-hidden {\r\n        white-space: wrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    &.has-ng-content {\r\n        display: inline-block;\r\n        \r\n        .formatted-value-display {\r\n            width: 75%;\r\n            display: inherit;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
